import type { JSX } from "react";
import { Icon, PageSectionHeader } from "../../components/ui";
import type { IconName } from "../../components/ui/Icon";
import { useUiStore } from "../../store/uiStore";

type ThemeMode = "dark" | "light" | "system";

const THEME_OPTIONS: readonly { value: ThemeMode; label: string; icon: IconName }[] = [
  { value: "dark", label: "Dark", icon: "moon" },
  { value: "light", label: "Light", icon: "sun" },
  { value: "system", label: "System", icon: "monitor" },
];

export function AppearancePanel(): JSX.Element {
  const theme = useUiStore((s) => s.theme);
  const setTheme = useUiStore((s) => s.setTheme);

  return (
    <div className="px-6 py-5 space-y-2">
      <PageSectionHeader
        title="Appearance"
        description="Customize the look and feel."
      />

      <div className="h-5" />

      <span className="text-[11px] font-bold tracking-wider text-accent uppercase">Theme</span>

      <div className="mt-2 rounded-xl bg-surface-tertiary border border-edge overflow-hidden divide-y divide-edge">
        {THEME_OPTIONS.map((opt) => {
          const active = opt.value === theme;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => { setTheme(opt.value); }}
              className="w-full flex items-center justify-between px-4 py-3.5 text-left cursor-pointer hover:bg-surface-hover transition-colors"
            >
              <div className="flex items-center gap-3">
                <Icon name={opt.icon} size={18} className={active ? "text-content" : "text-content-secondary"} />
                <span className={`text-sm font-medium ${active ? "text-content" : "text-content-secondary"}`}>
                  {opt.label}
                </span>
              </div>
              {active ? (
                <div className="w-5 h-5 rounded-full border-2 border-accent flex items-center justify-center">
                  <div className="w-2.5 h-2.5 rounded-full bg-accent" />
                </div>
              ) : (
                <div className="w-5 h-5 rounded-full border-2 border-content-muted" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
